import { makeAutoObservable, runInAction } from "mobx";
import type { RootStore } from "./root.store";
import type { TWorkspacePasswordPolicy, TWorkspacePasswordPolicyUpdate } from "@/types/workspace";

export class WorkspacePasswordPolicyStore {
  policy: TWorkspacePasswordPolicy | null = null;
  isLoading = false;
  isSaving = false;

  private rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, { rootStore: false } as never, { autoBind: true });
  }

  async fetchPolicy(slug: string): Promise<TWorkspacePasswordPolicy> {
    this.isLoading = true;
    try {
      const policy = await this.rootStore.workspacePasswordPolicyService.getPasswordPolicy(slug);
      runInAction(() => {
        this.policy = policy;
      });
      return policy;
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }

  async updatePolicy(
    slug: string,
    data: TWorkspacePasswordPolicyUpdate,
  ): Promise<TWorkspacePasswordPolicy> {
    this.isSaving = true;
    try {
      const policy = await this.rootStore.workspacePasswordPolicyService.updatePasswordPolicy(
        slug,
        data,
      );
      runInAction(() => {
        this.policy = policy;
      });
      return policy;
    } finally {
      runInAction(() => {
        this.isSaving = false;
      });
    }
  }
}
